/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import LogCannon from '@ace-clublabs/log-cannon';
import { ErrorCode, IConfigEntry, IProcessPaymentWithManifestRequest, PaymentType } from '@ace-clublabs/payment-types';
import {
  Alert,
  AlertTypography,
  AppHeaderBackButton,
  Box,
  Checkbox,
  CheckboxGroup,
  CheckboxTypography,
  Icon,
  Link,
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  StickyButton,
  Typography,
} from '@ace-clublabs/shared-component-library';
import { IPG_ErrorCode } from '@lib/types';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sources } from '../api/sources';
import cvvImage from '../assets/cvv.png';
import { PaymentReview } from '../containers/PaymentReview';
import { Pages } from '../shared/pages';
import { useGlobalState } from '../shared/state';
import { ErrorSeverity, ErrorType } from '../shared/types';
import { FieldErrorType, ICardFormFieldChange, ICardFormState, IFieldError } from '../types';
import { CardFormValidationHelper } from '../utils/cardFormValidationHelper';
import { getTermsUrl } from '../utils/methods';
import PaymentTokenHelper from '../utils/paymentTokenHelper';
import { ProcessPaymentHelper } from '../utils/processPaymentHelper';
import UrlHelper from '../utils/urlHelper';
import { UtagHelper } from '../utils/utagHelper';
import Header from './Header';
import PaymentHeader from './PaymentHeader';
import { PaymentMethodsAuthorizationModal } from './PaymentMethodsAuthorizationModal';

export interface CardFormProps {
  manifestId: string;
  paymentType: PaymentType;
  amount: number;
  returnUrl: string;
  isScheduled: boolean | undefined;
  autoPay?: boolean;
  tokenOnly?: boolean;
  tags?: object;
  appId?: string;
  softErrorCode?: ErrorCode;
  scheduledDate?: string;
  paymentFormSubtitle?: string;
  setParentProcessing?: any;
}

const CardForm: React.FC<CardFormProps> = (props) => {
  const navigate = useNavigate();
  const [paymentForm, setPaymentForm] = useState<any>();
  const [cardImage, setCardImage] = useState<any>();
  const [showModal, setShowModal] = useState(false);
  const [_paymentType] = useGlobalState('paymentType') || [];
  const [showCvvModal, setShowCvvModal] = useState(false);
  const [isProcessing, setProcessing] = useState(true);
  const [isPaymentReview, setPaymentReview] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [clientToken, setClientToken] = useState('');
  const [last4, setLast4] = useState('');
  const [manifest] = useGlobalState('manifest') || [];
  const [redirectMap, setRedirected] = useGlobalState('redirectMap') || [];
  const [showPaymentAuthorization, setShowPaymentAuthorization] = useState(false);
  const [isMobileApp] = useGlobalState('isMobileApp') || [];
  const [paymentMethodsSkipped, setpaymentMethodsSkipped] = useGlobalState('paymentMethodsSkipped') || [];
  const [, setPaymentProcessing] = useGlobalState('paymentProcessing');
  const [, setError] = useGlobalState('error') || [];

  const {
    manifestId,
    paymentType,
    amount,
    returnUrl,
    autoPay,
    tokenOnly,
    tags,
    appId,
    softErrorCode,
    scheduledDate,
    isScheduled,
    paymentFormSubtitle,
    setParentProcessing,
  } = props;

  const config = manifest?.clientConfig || ({} as IConfigEntry);
  const allowStoredPayment = config?.allowStoredPayment;
  const disableCVV = config?.disableCVV;
  const [storePaymentChecked, setStorePaymentChecked] = useState(false);

  const [cardHolderNameValidation, setCardHolderNameValidation] = useState<IFieldError>({
    type: FieldErrorType.None,
  });
  const [cardValidation, setCardValidation] = useState<IFieldError>({
    type: FieldErrorType.None,
  });
  const [expValidation, setExpValidation] = useState<IFieldError>({
    type: FieldErrorType.None,
  });
  const [cvvValidation, setCvvValidation] = useState<IFieldError>({
    type: FieldErrorType.None,
  });
  const [zipValidation, setZipValidation] = useState<IFieldError>({
    type: FieldErrorType.None,
  });

  const fieldsToValidate = disableCVV
    ? ['name', 'card', 'exp', 'postalCode']
    : ['name', 'card', 'exp', 'cvv', 'postalCode'];

  const processingType = {
    loading: {
      status: true,
      text: 'Your checkout is loading',
      cindy: true,
      displayCheckmark: true,
      callback: () => {
        setProcessing(false);
      },
    },
    paymentReview: {
      status: true,
      text: 'Hang tight while we get things ready for you.',
      cindy: false,
      displayCheckmark: false,
    },
    paymentReviewDone: {
      status: true,
      text: 'Hang tight while we get things ready for you.',
      cindy: false,
      displayCheckmark: true,
      callback: () => {
        setProcessing(false);
        setPaymentReview(true);
      },
    },
    paymentStart: {
      status: true,
      text: '',
      cindy: false,
      displayCheckmark: false,
    },
    paymentSuccess: {
      status: true,
      text: '',
      cindy: false,
      displayCheckmark: true,
    },
    tokenRedirectWithPaymentReview: {
      status: true,
      text: 'Hang tight while we get things ready for you.',
      cindy: false,
      displayCheckmark: true,
      callback: () => {
        setProcessing(false);
      },
    },
    dismissProcessing: {
      status: true,
      text: '',
      cindy: false,
      displayCheckmark: true,
      callback: () => {
        setProcessing(false);
      },
    },
  };

  useEffect(() => {
    (async () => {
      try {
        const _paymentForm = await PaymentTokenHelper.initPaymentForm(
          (window as any).firstdata,
          {
            preFlowHook: async (gatewayCallback: any) => {
              try {
                const authorizeSessionResponse = await PaymentTokenHelper.authorizeSession(manifestId);
                gatewayCallback(authorizeSessionResponse);
              } catch (error) {
                const errorMessage = 'ERROR: Authorize Session Exception';
                if (typeof error === 'string') {
                  LogCannon.blast(`${errorMessage}: ${error}`);
                } else {
                  LogCannon.blast(errorMessage, error as object);
                }
                navigate(Pages.Error);
              }
            },
          },
          disableCVV ? disableCVV : undefined
        );

        if (softErrorCode) {
          handleSoftError({ code: softErrorCode });
        }

        setParentProcessing(processingType.loading);
        setPaymentForm(_paymentForm);
      } catch (error) {
        const errorMessage = 'ERROR: First Data Form Initialization Error';
        if (typeof error === 'string') {
          LogCannon.blast(`${errorMessage}: ${error}`);
        } else {
          LogCannon.blast(errorMessage, error as object);
        }
        navigate(Pages.Error);
      }
    })();
  }, [manifestId]);

  useEffect(() => {
    if (paymentForm) {
      paymentForm.on('change', async (data: ICardFormFieldChange) => {
        const iconForCard = getIconForCard(paymentForm.state.data.fields.card.validity.brand);
        await setCardImage(iconForCard);

        paymentForm.getState((state: ICardFormState) => {
          let isFormValid: boolean = true;
          fieldsToValidate.forEach((field) => {
            const fieldState = state[field];
            const fieldValidation = CardFormValidationHelper.validateFormField(field, fieldState);
            const isFieldValid = fieldValidation.type === FieldErrorType.None;
            isFormValid = isFormValid && isFieldValid;
          });
          setFormValid(isFormValid);
        });
      });

      paymentForm.on('blur', async (data: ICardFormFieldChange) => {
        const fieldName = data.field;
        paymentForm.getState((state: ICardFormState) => {
          fieldsToValidate.forEach((field) => {
            const fieldState = state[field];
            const fieldValidation = CardFormValidationHelper.validateFormField(field, fieldState);
            if (field === fieldName) {
              switch (field) {
                case 'name':
                  setCardHolderNameValidation(fieldValidation);
                  break;
                case 'card':
                  setCardValidation(fieldValidation);
                  break;
                case 'exp':
                  setExpValidation(fieldValidation);
                  break;
                case 'cvv':
                  setCvvValidation(fieldValidation);
                  break;
                case 'postalCode':
                  setZipValidation(fieldValidation);
                  break;
              }
            }
          });
        });
      });
    }
  }, [paymentForm]);

  const redirect = (url: string) => {
    setRedirected({ ...redirectMap, [manifestId]: url });
    navigate(`/redirect/${manifestId}`);
  };

  const getIconForCard = (cardBrand: string) => {
    switch (cardBrand?.toLowerCase()) {
      case 'visa':
        return <Icon iconName="visa-logo" className="cardBrand" />;
      case 'american-express':
      case 'americanexpress':
      case 'amex':
        return <Icon iconName="amex-logo" className="cardBrand" />;
      case 'dinersclub':
      case 'discover':
        return <Icon iconName="discover-logo" className="cardBrand" />;
      case 'jcb':
        return <Icon iconName="jcb-logo" className="cardBrand" />;
      case 'unionpay':
        return <Icon iconName="union-pay-logo" className="cardBrand" />;
      case 'maestro':
      case 'mastercard':
        return <Icon iconName="mastercard-logo" className="cardBrand" />;
      default:
        return null;
    }
  };

  const handleStorePaymentCheck = () => setStorePaymentChecked((sp) => !sp);

  const renderPaymentReview = manifest?.clientConfig?.renderPaymentReview && amount > 0;
  const handleSubmit = (e: any) => {
    setParentProcessing(renderPaymentReview ? processingType.paymentReview : processingType.paymentStart);
    setProcessing(true);
    e.preventDefault();
    return paymentForm.onSubmit(tokenizationSuccessCallback, tokenizationErrorCallback);
  };

  const submitPayment = async (clientToken: any) => {
    const processPaymentBody = {
      manifestId: manifestId,
      clientToken,
      paymentType: pmtType === PaymentType.Undefined ? PaymentType.CreditOrDebit : pmtType,
      scheduledDate: scheduledDate,
    } as IProcessPaymentWithManifestRequest;

    if ((allowStoredPayment && storePaymentChecked) || appId === 'manage-saved-payments')
      processPaymentBody.storePayment = {
        enable: true,
      };
    setProcessing(true);
    setPaymentProcessing(true);
    const { transactionId } = await ProcessPaymentHelper.processPayment(processPaymentBody);
    setParentProcessing({
      ...processingType.paymentSuccess,
      callback: () => {
        const returnUrlWithTransactionId = UrlHelper.addQueryParam(returnUrl, { transactionId });
        redirect(returnUrlWithTransactionId);
      },
    });
  };

  const tokenizationSuccessCallback = async (clientToken: any) => {
    let tokenStatus;
    let counter = 0;

    try {
      const failedtokens = sessionStorage.getItem('failedtokens');
      const failedTokensArray = failedtokens ? failedtokens?.split(',') : [];
      if (failedTokensArray?.includes(clientToken)) {
        LogCannon.blast(`Tokenization attempted with previously failed token - clientToken: ${clientToken}`);
        return;
      }

      while (counter < 10) {
        counter++;
        LogCannon.blast(`Attempting getCardTokenStatus api - counter: ${counter}, waiting period: 1500ms`);
        tokenStatus = await sources.getCardTokenStatus(clientToken);
        LogCannon.blast(`Attempting getCardTokenStatus api - counter: ${counter}, result`, {
          manifestId,
          tokenStatus,
          isoTimeStamp: new Date().toISOString(),
        });
        const errorCode = tokenStatus?.error?.code;
        if (errorCode) {
          setPaymentReview(false);
          setParentProcessing(processingType.dismissProcessing);
          return handleSoftError({ code: errorCode });
        } else if (tokenStatus?.last4) {
          break;
        } else {
          await new Promise((resolve) => setTimeout(resolve, 1500));
        }
      }

      if (!tokenStatus?.last4) {
        setParentProcessing(processingType.dismissProcessing);
        return handleSoftError({ code: ErrorCode.GatewayTokenFailedToWrite });
      } else await setLast4(tokenStatus.last4);

      if (isScheduled && scheduledDate) {
        if (tokenStatus?.exp) {
          const { month, year } = tokenStatus.exp;
          let tokenExp = new Date(parseInt(year), parseInt(month), 0);

          let scheduled = new Date(scheduledDate);
          if (dayjs(scheduled).isAfter(dayjs(tokenExp))) {
            setParentProcessing(processingType.dismissProcessing);
            setPaymentReview(false);
            return handleSoftError({ code: 'scheduled_after_expiration_date' as ErrorCode });
          }
        }
      }

      setClientToken(clientToken);

      if (tokenOnly && tokenStatus) {
        if (renderPaymentReview) {
          setParentProcessing(processingType.tokenRedirectWithPaymentReview);
          setPaymentReview(true);
        } else {
          setParentProcessing(processingType.dismissProcessing);
          return redirect(returnUrl);
        }
      } else if (renderPaymentReview) {
        setParentProcessing(processingType.paymentReviewDone);
      } else {
        await submitPayment(clientToken);
      }
    } catch (error: any) {
      setParentProcessing(processingType.dismissProcessing);
      if (error.type === ErrorSeverity.SOFT) {
        setPaymentReview(false);
        handleSoftError(error);
      } else {
        handleFailedTokens(clientToken);

        const errorData = {
          manifestId,
          tokenStatus,
          isoTimeStamp: new Date().toISOString(),
        };
        const errorMessage = `ERROR: Tokenization Retry - Counter: ${counter}`;
        if (typeof error === 'string') {
          LogCannon.blast(`${errorMessage}: ${error}`, errorData);
        } else {
          LogCannon.blast(errorMessage, { ...error, errorData } as object);
        }
        if (error.code === ErrorCode.TooManyRequests) {
          setError({ errorType: ErrorType.RATE_LIMITED, errorMessage: '' });
        }
        navigate(Pages.Error);
      }
    }
  };

  const submitPaymentFromReview = async (clientToken: string) => {
    setParentProcessing(processingType.paymentStart);
    try {
      await submitPayment(clientToken);
    } catch (error: any) {
      setParentProcessing(processingType.dismissProcessing);
      if (error.type === ErrorSeverity.SOFT) {
        setPaymentReview(false);
        handleSoftError(error);
      } else {
        handleFailedTokens(clientToken);
        const errorMessage = 'ERROR: Submit Payment From Review Exception';
        if (typeof error === 'string') {
          LogCannon.blast(`${errorMessage}: ${error}`);
        } else {
          LogCannon.blast(errorMessage, error as object);
        }
        if (error.code === ErrorCode.TooManyRequests) {
          setError({ errorType: ErrorType.RATE_LIMITED, errorMessage: '' });
        }
        navigate(Pages.Error);
      }
    }
  };

  const handleFailedTokens = (clientToken: string) => {
    const failedtokens = sessionStorage.getItem('failedtokens');
    const failedTokensArray = failedtokens ? failedtokens?.split(',') : [];
    if (!failedTokensArray?.includes(clientToken)) {
      failedTokensArray?.push(clientToken);
    }
    const failedTokensString = failedTokensArray?.join(',') || '';
    sessionStorage.setItem('failedtokens', failedTokensString);
  };

  const tokenizationErrorCallback = async (error: any = {}) => {
    const errorMessage = 'ERROR: Tokenization Error';
    if (typeof error === 'string') {
      LogCannon.blast(`${errorMessage}: ${error}`);
    } else {
      LogCannon.blast(errorMessage, error as object);
    }
    navigate(Pages.Error);
  };

  const handleSoftError = (error: { code: ErrorCode | IPG_ErrorCode }) => {
    if (tags) {
      const paymentTags = UtagHelper.tagPage(tags, 'payment');
      paymentTags['error'] = `blocked payment-${error.code}`;
      UtagHelper.link(paymentTags);
    }

    switch (error.code?.toLowerCase()) {
      case ErrorCode.InvalidAccountHolderName:
        setCardHolderNameValidation({
          type: FieldErrorType.IsNotValid,
          message: 'Invalid Name on the card.',
        });
        break;
      case ErrorCode.InvalidExpirationDate:
        setExpValidation({
          type: FieldErrorType.IsNotValid,
          message: 'Invalid expiration date.',
        });
        break;
      case 'scheduled_after_expiration_date':
        setCardValidation({
          type: FieldErrorType.IsNotValid,
          message: 'The card entered expires before your scheduled payment date.',
        });
        break;
      case ErrorCode.InvalidCard:
      case ErrorCode.InvalidToken:
      case ErrorCode.InvalidInsuranceAutopayPaymentMethod:
      case ErrorCode.CardTypeNotAllowed:
      case ErrorCode.InvalidAccountNumber:
        setCardValidation({
          type: FieldErrorType.IsNotValid,
          message: 'Invalid card number.',
        });
        break;
      case ErrorCode.StorePaymentError:
        setCardValidation({
          type: FieldErrorType.IsNotValid,
          message: 'Sorry, your payment method could not be saved for future payments.',
        });
        break;
      case ErrorCode.UnknownCardType:
      case ErrorCode.StandaloneAutoPayError:
      case ErrorCode.InvalidPaymentGatewayToken:
      case IPG_ErrorCode.Rejected:
        setCardValidation({
          type: FieldErrorType.IsNotValid,
          message: 'The card entered is not supported. Please try a different card.',
        });
        break;
      case ErrorCode.ChargeDeclined:
        setCardValidation({
          type: FieldErrorType.IsNotValid,
          message: 'Charge declined, please use a different card.',
        });
        break;
      case ErrorCode.CreditCardNotAllowed:
        setCardValidation({
          type: FieldErrorType.IsNotValid,
          message: 'Only debit cards are accepted, please try again.',
        });
        break;
      case ErrorCode.DebitCardNotAllowed:
        setCardValidation({
          type: FieldErrorType.IsNotValid,
          message: 'Debit cards are not accepted, please try again.',
        });
        break;
      case ErrorCode.PrepaidCardNotAllowedForAutoPay:
      case ErrorCode.PrepaidCardNotAllowed:
        setCardValidation({
          type: FieldErrorType.IsNotValid,
          message: 'Prepaid cards are not accepted, please try again.',
        });
        break;
      case ErrorCode.CardMustBeAAAVisa:
        setCardValidation({
          type: FieldErrorType.IsNotValid,
          message: 'Card must be a AAA Visa card.',
        });
        break;
      case ErrorCode.GatewayTokenFailedToWrite:
        setCardValidation({
          type: FieldErrorType.IsNotValid,
          message: 'System error occurred. Please try submitting again.',
        });
        break;
      case ErrorCode.InvalidZipCode:
        setZipValidation({
          type: FieldErrorType.IsNotValid,
          message: 'Invalid billing ZIP code.',
        });
        break;
      case IPG_ErrorCode.MissingCVV:
        setCvvValidation({
          type: FieldErrorType.IsNotValid,
          message: 'Invalid CVV/security code.',
        });
        break;
      case ErrorCode.NetworkTimeout:
        if (appId === 'manage-saved-payments') {
          setCardValidation({
            type: FieldErrorType.IsNotValid,
            message: 'Your payment method could not be saved. Please try again.',
          });
        }
        break;
      default:
        setShowModal(true);
        break;
    }
  };

  const cvvModalHandler = (e: any) => {
    setShowCvvModal(true);
    e.preventDefault();
  };

  const modalDialog = (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      variants={{
        xs: 'bottom-sheet',
        sm: 'regular',
      }}
    >
      <ModalTitle id={`error-modal-title`} sx={{ marginRight: '2rem' }}>
        Please try again.
        <ModalCloseIconButton aria-label="Close" onClick={() => setShowModal(false)} />
      </ModalTitle>

      <ModalContent id="error-modal-content">
        <Typography variant="b1Regular">There was an unexpected error.</Typography>
      </ModalContent>
      <ModalActions
        actionLayout={{
          sm: 'fullWidth',
          md: 'fullWidth',
          lg: 'rightAlign',
          xl: 'rightAlign',
        }}
      >
        <ModalActionButton label="OK" onClick={() => setShowModal(false)} />
      </ModalActions>
    </Modal>
  );

  const cvvModal = (
    <Modal
      open={showCvvModal}
      onClose={() => setShowCvvModal(false)}
      variants={{
        xs: 'bottom-sheet',
        sm: 'regular',
      }}
    >
      <ModalTitle id={`modal-title-cvv`} sx={{ marginRight: '2rem' }}>
        Where do I find this?
        <ModalCloseIconButton aria-label="Close" onClick={() => setShowCvvModal(false)} />
      </ModalTitle>

      <ModalContent id="modal-content-cvv">
        <Typography variant="b1Regular">
          The CVV or Card Verification Value is a 3-digit code usually found on the back of Visa or Mastercard credit
          and debit cards. For American Express cards, it is a 4-digit code on the front of your card.
        </Typography>
        <div className="cvv-img-div">
          <img src={cvvImage} className="cvv-img" alt="cvv" />
        </div>
      </ModalContent>
      <ModalActions
        actionLayout={{
          sm: 'fullWidth',
          md: 'fullWidth',
          lg: 'rightAlign',
          xl: 'rightAlign',
        }}
      >
        <ModalActionButton label="Got it" onClick={() => setShowCvvModal(false)} />
      </ModalActions>
    </Modal>
  );

  const isScheduledPayment: boolean = !!isScheduled || !!manifest?.isScheduled;
  const authText = isScheduledPayment || amount <= 0 || renderPaymentReview ? 'Continue' : 'Pay now';

  const isMap = appId === 'manage-autopay';
  const isStorePaymentFlow = amount === 0 && !autoPay;
  const mapChangeFlow = isMap && manifest?.renderTsAndCs?.render;
  const mapNewEnrollFlow = isMap && !manifest?.renderTsAndCs?.render;
  const renderTermsAndPaymentAuth = mapChangeFlow && paymentMethodsSkipped;
  const willVisitPaymentReview = renderPaymentReview && amount > 0;
  const renderPaymentAuth =
    !renderTermsAndPaymentAuth &&
    ((mapNewEnrollFlow && amount === 0) || mapChangeFlow || !(willVisitPaymentReview || isStorePaymentFlow));
  const renderNoChargeAlert = config?.renderNoChargeAlert && amount === 0;

  const handleBack = () => {
    if (paymentMethodsSkipped) {
      setpaymentMethodsSkipped(false);
      navigate(-2);
    } else navigate(-1);
  };

  const pmtType =
    paymentType && paymentType !== PaymentType.Undefined
      ? paymentType
      : _paymentType && _paymentType !== PaymentType.Undefined
        ? _paymentType
        : PaymentType.Undefined;

  return (
    <>
      {isPaymentReview && !isProcessing && (
        <PaymentReview
          amount={manifest?.amount!}
          paymentDetails={{
            paymentType: PaymentType.Undefined,
            card: {
              brand: paymentForm.state.data.fields.card.validity.brand,
              last4,
            },
          }}
          pit={manifest?.pit ? { ...manifest.pit } : undefined}
          scheduledDate={scheduledDate}
          tokenProps={tokenOnly ? { manifestId, returnUrl } : undefined}
          onSubmit={() => {
            submitPaymentFromReview(clientToken);
          }}
          onBack={() => setPaymentReview(false)}
        />
      )}

      <div className="payment-form" tabIndex={0} style={isProcessing || isPaymentReview ? { display: 'none' } : {}}>
        <div className="payment-form-cream-section">
          <div className="payment-form-body inner-container">
            <Header />
            {!isMobileApp && <AppHeaderBackButton id="back-button" onClick={handleBack} />}
            <Box className="secure-checkout">
              <Icon iconName="lock-keyhole-solid" className="lock-icon" />
              <span>Secure checkout</span>
            </Box>
            <PaymentHeader paymentType={pmtType} amount={amount} autoPay={autoPay} />
            {paymentFormSubtitle ? (
              <Typography variant="b1Regular" data-quid="card-form-subtitle">
                {paymentFormSubtitle}
              </Typography>
            ) : (
              <Box id="card-form-subtitle-container">
                {config?.allowedPaymentTypes?.includes(PaymentType.DebitOnly) && (
                  <Box className="card-subtitle" id="payment-method-debit-card">
                    <Typography variant="b1Regular" data-quid="card-form-subtitle">
                      Debit card
                    </Typography>
                    <Box className="card-logo" id="debit-card-logos">
                      <Icon iconName="mastercard-logo" className="card-header-icons" />
                      <Icon iconName="visa-logo" className="card-header-icons" />
                    </Box>
                  </Box>
                )}
                {config?.allowedPaymentTypes?.includes(PaymentType.CreditOrDebit) && (
                  <Box className="card-subtitle" id="payment-method-credit-card" sx={{ alignContent: 'space-between' }}>
                    <Typography variant="b1Regular" data-quid="card-form-subtitle">
                      Credit card
                    </Typography>
                    <Box className="card-logo" id="credit-card-logos">
                      <Icon iconName="amex-logo" className="card-header-icons" />
                      <Icon iconName="mastercard-logo" className="card-header-icons" />
                      <Icon iconName="visa-logo" className="card-header-icons" />
                      <Icon iconName="discover-logo" className="card-header-icons" />
                    </Box>
                  </Box>
                )}
              </Box>
            )}
          </div>
        </div>
        <div className="payment-form-body inner-container">
          {renderNoChargeAlert && (
            <Alert severity="info" id="no-charge-info-alert" displayCloseButton={false}>
              <AlertTypography>
                You won't be charged today—your payment info is being saved for Auto Pay.
              </AlertTypography>
            </Alert>
          )}
          <form id="ipg-form">
            <div className="input-wrapper">
              <Typography variant="b2Regular" component="label" id="cc-name-label">
                Name on the card
              </Typography>
              <div
                id="cc-name"
                className={`payment-field${cardHolderNameValidation.type !== FieldErrorType.None ? ' invalidClass' : ''
                  }`}
              />
              {cardHolderNameValidation.type !== FieldErrorType.None && (
                <Typography variant="b2Regular" id="name-validation" className="validation-error-message">
                  <Icon iconName="triangle-exclamation-solid" />
                  {cardHolderNameValidation.message}
                </Typography>
              )}
            </div>
            <div className="input-wrapper">
              <Typography variant="b2Regular" component="label" id="cc-number-label">
                Card number
              </Typography>
              <div className="cc-card-field">
                <div
                  id="cc-card"
                  className={`payment-field${cardValidation.type !== FieldErrorType.None ? ' invalidClass' : ''}`}
                />
                {cardImage && <span className="cc-card-brand">{cardImage}</span>}
              </div>
              {cardValidation.type !== FieldErrorType.None && (
                <Typography variant="b2Regular" id="card-validation" className="validation-error-message">
                  <Icon iconName="triangle-exclamation-solid" />
                  {cardValidation.message}
                </Typography>
              )}
            </div>
            <div className="inline">
              <div id="exp-container" className="input-wrapper">
                <Typography variant="b2Regular" component="label" id="cc-exp-label">
                  Expiration date
                </Typography>
                <div
                  id="cc-exp"
                  className={`payment-field half-width${expValidation.type !== FieldErrorType.None ? ' invalidClass' : ''
                    }`}
                />
                {expValidation.type !== FieldErrorType.None && (
                  <Typography variant="b2Regular" id="exp-validation" className="validation-error-message">
                    <Icon iconName="triangle-exclamation-solid" />
                    {expValidation.message}
                  </Typography>
                )}
                <div data-quid="helper-text" className="helper-text">
                  MM/YY
                </div>
              </div>

              <div id="cvv-container" className={`input-wrapper ${disableCVV ? 'hide-input' : ''}`}>
                <Typography variant="b2Regular" component="label" id="cc-cvv-label">
                  CVV/security code
                </Typography>
                <div
                  id="cc-cvv"
                  className={`payment-field half-width${cvvValidation.type !== FieldErrorType.None ? ' invalidClass' : ''
                    }`}
                />
                <Link component="button" id="cvv-desc-link" onClick={cvvModalHandler}>
                  Where do I find this?
                </Link>
                {cvvValidation.type !== FieldErrorType.None && (
                  <Typography variant="b2Regular" id="cvv-validation" className="validation-error-message">
                    <Icon iconName="triangle-exclamation-solid" />
                    {cvvValidation.message}
                  </Typography>
                )}
              </div>
            </div>
            <div className="input-wrapper">
              <Typography variant="b2Regular" component="label" id="cc-zip-label">
                Billing ZIP code
              </Typography>
              <div
                id="cc-zip"
                className={`payment-field${zipValidation.type !== FieldErrorType.None ? ' invalidClass' : ''
                  }`}
              />
              {zipValidation.type !== FieldErrorType.None && (
                <Typography variant="b2Regular" id="zip-validation" className="validation-error-message">
                  <Icon iconName="triangle-exclamation-solid" />
                  {zipValidation.message}
                </Typography>
              )}
            </div>

            {allowStoredPayment && (
              < CheckboxGroup className="save-this-payment" variant="text">
                <Checkbox
                  name="store-payment"
                  checked={storePaymentChecked}
                  label={<CheckboxTypography>Save for future payments</CheckboxTypography>}
                  value="store-payment"
                  enableForm={false}
                  onClick={() => handleStorePaymentCheck()}
                />
              </CheckboxGroup>
            )}
          </form>
          {renderPaymentAuth && (
            <Typography variant="b2Regular" data-quid="payment-authorization-text-card">
              By clicking {authText}, I hereby state that I am an authorized user for the above payment method, and have
              read and agree to the{' '}
              <Link
                id="payment-authorization-link"
                component="button"
                sx={{ verticalAlign: 'baseline' }}
                onClick={() => {
                  setShowPaymentAuthorization(true);
                }}
                variant="b2Regular"
              >
                Payment Authorization
              </Link>
              .
            </Typography>
          )}
          {renderTermsAndPaymentAuth && (
            <Typography variant="b2Regular" className="terms-and-conditions">
              By clicking Continue, I hereby enroll in Auto Pay and that I am an authorized user for the above payment
              method I have selected, and have read and agree to the{' '}
              <Link
                data-id="terms-conditions-link"
                id="terms-conditions-link"
                variant="b2Regular"
                href={getTermsUrl()}
                target="_blank"
                sx={{ verticalAlign: 'baseline' }}
              >
                Terms & Conditions
              </Link>{' '}
              <Typography variant="b2Regular" sx={{ display: 'inline-block' }}>
                and{' '}
              </Typography>
              <Link
                data-id="terms-conditions-link"
                variant="b2Regular"
                component="button"
                sx={{ verticalAlign: 'baseline' }}
                onClick={() => {
                  setShowPaymentAuthorization(true);
                }}
              >
                Payment Authorization
              </Link>
              .
            </Typography>
          )}
        </div>
        {showPaymentAuthorization && (
          <PaymentMethodsAuthorizationModal
            handleClose={() => {
              setShowPaymentAuthorization(false);
            }}
            ctaText={authText}
          ></PaymentMethodsAuthorizationModal>
        )}
        <StickyButton
          id="cc-submit"
          slotProps={{
            primaryButton: {
              label: authText,
              onClick: handleSubmit,
              disabled: !formValid,
              endIcon: !renderNoChargeAlert && amount > 0 ? <Icon iconName="lock-keyhole-solid" /> : undefined,
            },
          }}
          renderAmount={renderNoChargeAlert || amount > 0 ? amount : undefined}
        />
      </div>

      {modalDialog}
      {cvvModal}
    </>
  );
};

export default CardForm;
